<template>
  <div class="duration-filter">
    <LISAInput v-model.number="numberOfDays" type="number" hide-label :label="t('global.days')">
      <template #append>{{ t("global.days") }}</template>
    </LISAInput>
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { LISAInput } from "@fi-solutions/lisa-ui";
import { ref } from "vue";
import { useTranslation } from "@/language/translation";
import OverdueFilter from "../filterImplementations/OverdueFilter";

const { t } = useTranslation();
const numberOfDays = ref<number>();
function getFilter() {
  return numberOfDays.value == null ? null : new OverdueFilter(numberOfDays.value * 24);
}
function applyFilter(filter: OverdueFilter) {
  numberOfDays.value = filter.definitionOfOverdueInHours / 24;
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped>
.duration-filter {
  width: 100%;
}
</style>
